import DispatchDocketList from './List';
import DispatchDocketEdit from './Form';

export default {
  list: DispatchDocketList,
  edit: DispatchDocketEdit,
};
